export function getVoucherType(type) {
  switch (type) {
    case 'IFOOD':
      return 'iFood'
    case 'UBER':
      return 'Uber'
    case 'RECHARGE':
      return 'Recarga'
    case 'TINDER':
      return 'Tinder'
    case 'POINTS':
      return 'Pontos Zé Compensa'
    default:
      return type
  }
}
